export default __webpack_public_path__ + "static/SoftwareIDEv2-6a18a1143b1f9e6498ebba2fe747b6d3.svg";